import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box, Typography, Stack, IconButton } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Images } from "./../../assets/common";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import {
  convertHMS,
  fullName,
  getErrorString,
  getUserDetail,
  isOwner,
  isOwnerId,
  kFormatter,
  screenWidth,
  truncate,
} from "../../constants/function";
import { useDispatch, useSelector } from "react-redux";
import { addSongAction, addSongsAction } from "./../../action/songs";
import DoneIcon from "@mui/icons-material/Done";

import LockIcon from "@mui/icons-material/Lock";
import OutsideClickHandler from "react-outside-click-handler";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import "./index.scss";
import notifier from "./../../components/Notifier";
import { UserContext } from "../../context/userContext";
import { logBase } from "@syncfusion/ej2-react-charts";
import DobPopup from "../DobPopup";
import TipCount from "../../pages/TipCount";
import { useTranslation } from "react-i18next";
import emitter from '../../EventEmitter';
import { act } from '../../constants/common';
import VerificationSVG from './../../assets/common/artistProfile/Verification.svg';
import LiveStreamSnapshot from '../LiveStreamSnapshot';
import PlayIcon from "../icons/PlayIcon";


export default function MusicCard({
  actions,
  toggleMenu,
  isAlbum,
  music,
  isArtist,
  isMusic,
  isPlaylist,
  isTopMusic,
  cardIndex,
  noActions,
  isNft,
  onHistory,
  isFeature,
  ownerRoyalty,
  isPlaylistNft,
  nftId,
  playSongs,
  songIndex,
  isPrivate,
  isHome,
  isSubscribed,
  isExplore,
  owner,
  hideIcons,
  name,
  image,
  platform,
  tip,
  listens,
  tab,
  isStreaming,
  onStream,
  isSearch,
}) {
  const theme = useTheme();
  const [message, setMessage] = React.useState(null);
  const { t } = useTranslation("common");
  const [loading, setLoading] = React.useState(false);
  const [isMenu, setMenu] = React.useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  // const { userData } = useContext(UserContext);
  const userData = getUserDetail();
  const [birthYear, setBirthYear] = React.useState(false);
  const [img, setImg] = useState(
    isPlaylist || isPlaylistNft
      ? music["thumbnailImg"]?.["filePath"] || Images.default_playlist
      : Images.default_music
  );

  const navTo = (page) => {
    emitter.emit( act.CLOSE_DRAWER )
    history.push(page);
  }


  React.useEffect(() => {
    setImg(
      isArtist
        ? music["profileImg"] && music["profileImg"]["filePath"] != ""
          ? music["profileImg"]["filePath"]
          : Images.default_user_square
        : isMusic
        ? music["thumbnailImg"]
          ? music["thumbnailImg"]["filePath"]
          : Images.default_music
        : isPlaylist || isPlaylistNft
        ? music["GIF"]
          ? music["GIF"]["filePath"]
          : music["Gif"]
          ? music["Gif"]["filePath"]
          : music["thumbnailImg"]
          ? music["thumbnailImg"]["filePath"]
          : Images.default_playlist
        : isAlbum
        ? music["thumbnailImg"]
          ? music["thumbnailImg"]["filePath"]
          : Images.default_album
        : isNft
        ? music["GIF"]
          ? music["GIF"]["filePath"]
          : music["Gif"]
          ? music["Gif"]["filePath"]
          : music["thumbnailImg"]
          ? music["thumbnailImg"]["filePath"]
          : Images.default_music
        : Images.default_music
    );
  }, [music["_id"], name, image, music?.GIF?.filePath]);
  const redirectNft = (redirectToPlaylistDetail) => {
    if (isOwnerId(music["createdBy"] ? music["createdBy"] : ""))
      navTo(`/app/Music/${music["_id"]}`);
    else if (
      !isOwnerId(music["createdBy"] ? music["createdBy"] : "") &&
      !isSubscribed &&
      isPrivate
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (
      !isOwnerId(music["creatorId"] ? music["creatorId"] : "") &&
      !isSubscribed &&
      isPrivate
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (
      typeof music["uploader"] === "object" &&
      !isOwner(music["uploader"] ? music["uploader"]["email"] : "") &&
      music["uploader"] &&
      !music["uploader"]["isSubscribed"] &&
      music["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else if (redirectToPlaylistDetail)
      navTo(`/app/Music/${music["_id"]}`);
    else
      navTo(
        `/app/PlaylistNftDetail/${
          music["nftId"] ? music["nftId"] : music["_id"]
        }`
      );
  };
  const addSong = () => {
    if (
      typeof music["uploader"] === "string" &&
      !isOwnerId(music["uploader"] ? music["uploader"] : "") &&
      !music["isSubscribed"] &&
      music["private"]
    )
      notifier.error(t("notifier.error.toast5"));
    else if (
      typeof music["uploader"] === "object" &&
      !isOwnerId(music["uploader"] ? music["uploader"]["_id"] : "") &&
      music["uploader"] &&
      !music["uploader"]["isSubscribed"] &&
      music["private"]
    )
      notifier.error(t("notifier.error.toast5"));
    else dispatch(addSongAction(music));
  };
  const redirect = () => {
    if (onHistory) {
      onHistory();
    } else if (
      isOwnerId(
        music["createdByDetails"]
          ? music["createdByDetails"]["_id"]
          : music["creatorId"]
          ? music["creatorId"]
          : music["createdBy"]
          ? music["createdBy"]
          : null
      )
    ) {
      if (onHistory) {
        onHistory();
      } else navTo(`/app/Music/${music["_id"]}`);
    } else if (typeof music["createdByDetails"] === "object") {
      if (
        !isOwner(
          music["createdByDetails"] ? music["createdByDetails"]["email"] : ""
        ) &&
        music["createdByDetails"] &&
        !music["createdByDetails"]["isSubscribed"] &&
        music["private"]
      ) {
        notifier.error(t("notifier.error.toast5"));
      } else navTo(`/app/Music/${music["_id"]}`);
    } else if (
      !isOwnerId(music["creatorId"] ? music["creatorId"] : "") &&
      !music["isSubscribed"] &&
      music["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else navTo(`/app/Music/${music["_id"]}`);
  };
  const addSongs = async (songs) => {
    if (onHistory) {
      onHistory();
    } else if (
      typeof music["createdByDetails"] === "object" &&
      isOwnerId(music["createdByDetails"]["_id"])
    ) {
      if (onHistory) {
        onHistory();
      } else navTo(`/app/Music/${music["_id"]}`);
    } else if (typeof music["createdByDetails"] === "object") {
      if (
        !isOwner(
          music["createdByDetails"] ? music["createdByDetails"]["email"] : ""
        ) &&
        music["createdByDetails"] &&
        !music["createdByDetails"]["isSubscribed"] &&
        music["private"]
      ) {
        notifier.error(t("notifier.error.toast5"));
      } else navTo(`/app/Music/${music["_id"]}`);
    } else if (
      !isOwnerId(music["creatorId"] ? music["creatorId"] : "") &&
      !music["isSubscribed"] &&
      music["private"]
    )
      notifier.error(t("notifier.error.toast5"));
    else navTo(`/app/Music/${music["_id"]}`);
  };
  const getPlayListMusic = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });

      setLoading(false);

      return response["result"]["music"] || [];
    } catch (error) {
      setLoading(false);
      return [];
    }
  };
  const addArtistSongs = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.ALL_ARTIST_MUSIC({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });
      if (response["result"]["music"])
        dispatch(addSongsAction(response["result"]["music"]));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getNftDetails = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.NFT_BY_ID(_id);

      if (response["result"] && response["result"]["musicDetails"])
        dispatch(addSongAction(response["result"]["musicDetails"]));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const [size, setSize] = useState();
  useLayoutEffect(() => {
    function updateSize() {
      setSize(screenWidth());
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const addArtistSong = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.ALL_ARTIST_MUSIC({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });
      if (response["result"]["music"] && response["result"]["music"].length)
        dispatch(addSongsAction(response["result"]["music"]));
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {}, [music]);
  const handleSongNameClick = (title, artist, playlist) => {
    // if (title && !artist && !playlist)
    //   navTo(`/app/SongDetails/${music["_id"]}`);
    // else if (artist) navTo(`/app/ArtistProfile/${music["_id"]}`);
    // else if (playlist) navTo(`/app/Music/${music["_id"]}`);
  };
  const reditectToProfile = (curentSong) => {
    if (typeof curentSong["createdByDetails"] === "object")
      navTo(
        `/app/ArtistProfile/${curentSong["createdByDetails"]["_id"]}`
      );
    else if (typeof curentSong["creatorId"] === "string")
      navTo(`/app/ArtistProfile/${curentSong["creatorId"]}`);
    else if (typeof curentSong["createdBy"] === "string")
      navTo(`/app/ArtistProfile/${curentSong["createdBy"]}`);
  };

  const redirectNftDetail = () => {
    if (isNft && !isSubscribed && isPrivate) {
      notifier.error(t("notifier.error.toast9"));
    } else {
      navTo(
        `/app/MyNft/${
          nftId ? nftId : music["nftId"] ? music["nftId"] : music["_id"]
        }`
      );
    }
  };
  const handleTip = async () => {
    setBirthYear(false);
  };
  const startStream = () => {
    if (userData._id !== music?.createdByDetails?._id)
      console.log("Navigating to live stream with channel:", music["channelName"]);

      onStream(music["channelName"]);
  };

  const frontend_artist = music["artist"]
    ? music["artist"].replace(/\//g, ", ")
    : "";

  return (
    <Box className={"__music_card"}>
      <Box sx={{ position: "relative", minWidth: "150px" }}>
        {isStreaming && (music.channelName || music._id) ? (
          <LiveStreamSnapshot
            channelName={music.channelName || music._id}
            fallbackImage={img}
            onClick={() => startStream()}
          />
        ) : (
          <img
            style={{ boxShadow: "0px 0px 4px #2e2e2e" }}
            className="__music_Card_image"
            src={img}
            onClick={() => {
              console.log('[MusicCard] Image clicked, isPlaylist:', isPlaylist, 'onHistory:', !!onHistory);
              // If onHistory prop is provided (like in search), use it
              if (onHistory && isPlaylist) {
                console.log('[MusicCard] Calling onHistory for playlist');
                onHistory(isPlaylistNft);
              } else if (isStreaming) {
                startStream()
              } else if (isMusic && isHome) {
                playSongs(songIndex)
              } else if (isAlbum && userData && !userData["birthYear"]) {
                setBirthYear(true)
              } else if (isAlbum) {
                navTo(`/app/AlbumDetail/${music["_id"]}`)
              } else if (isPlaylist && !isPlaylistNft) {
                addSongs(music)
              } else if (isArtist) {
                navTo(`/app/ArtistProfile/${music["_id"]}`)
              } else if (isPlaylistNft && userData && !userData["birthYear"]) {
                setBirthYear(true)
              } else if (isPlaylistNft) {
                redirectNft(true)
              } else if (isNft) {
                redirectNftDetail()
              } else if (isMusic && isExplore) {
                playSongs(songIndex)
              } else {
                addSong();
              }
            }}
            alt=""
          />
        )}
        {hideIcons || isStreaming ? null : (
          <Box
            className="__options"
            sx={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "210px",
              height: "210px",
              top: 0,
            }}
          >
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                isArtist
                  ? navTo(`/app/ArtistProfile/${music["_id"]}`)
                  : isPlaylist && !isPlaylistNft
                  ? redirect()
                  : isAlbum
                  ? navTo(`/app/MyAlbumDetail/${music["_id"]}`)
                  : isPlaylistNft
                  ? redirectNft(true)
                  : isNft && !isMusic
                  ? redirectNftDetail()
                  : isMusic && isHome
                  ? playSongs(songIndex)
                  : isMusic && isNft
                  ? addSong()
                  : addSong();
              }}
            >
              <PlayIcon className="__responsive_play" sx={{ fontSize: 30 }} />
            </IconButton>
            {noActions ? null : (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setMenu(!isMenu);
                }}
              >
                <MoreVertIcon
                  className="__responsive_play"
                  sx={{
                    color: theme.palette.primary.main,
                    background: alpha(
                      theme.palette.primary.main,
                      theme.palette.mode === "light" ? 0.15 : 0.35
                    ),
                    borderRadius: "50%",
                    fontSize: "30px",
                  }}
                />
              </IconButton>
            )}
          </Box>
        )}
        {(isNft || isPlaylistNft || music["nftId"]) && platform ? (
          platform === "Hedera" ? (
            <img
              className="_cp"
              title={t("dropMenu.m8")}
              onClick={() =>
                history.location.pathname.includes("/app/ArtistProfile/")
                  ? toggleMenu("m8", nftId ? nftId : music["nftId"])
                  : onHistory
                  ? onHistory(true)
                  : navTo(
                      `/app/${
                        isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                      }/${nftId ? nftId : music["nftId"]}`
                    )
              }
              style={{
                position: "absolute",
                width: "30px",
                left: "6px",
                bottom: "8px",
              }}
              src={Images.hbar_2}
              alt="nft"
            />
          ) : platform === "Polygon" ? (
            <img
              className="_cp"
              title={t("dropMenu.m8")}
              onClick={() =>
                history.location.pathname.includes("/app/ArtistProfile/")
                  ? toggleMenu("m8", nftId ? nftId : music["nftId"])
                  : onHistory
                  ? onHistory(true)
                  : navTo(
                      `/app/${
                        isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                      }/${nftId ? nftId : music["nftId"]}`
                    )
              }
              style={{
                position: "absolute",
                width: "30px",
                left: "6px",
                bottom: "8px",
              }}
              src={Images.polygoon2}
              alt="polygon"
            />
          ) : platform === "Siki" ? (
            <img
              className="_cp"
              title={t("dropMenu.m8")}
              onClick={() =>
                history.location.pathname.includes("/app/ArtistProfile/")
                  ? toggleMenu("m8", nftId ? nftId : music["nftId"])
                  : onHistory
                  ? onHistory(true)
                  : navTo(
                      `/app/${
                        isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                      }/${nftId ? nftId : music["nftId"]}`
                    )
              }
              style={{
                position: "absolute",
                width: "30px",
                left: "6px",
                bottom: "8px",
              }}
              src={Images.sikitoken}
              alt="siki"
            />
          ) : (
            <img
              className="_cp"
              title={t("dropMenu.m8")}
              onClick={() =>
                history.location.pathname.includes("/app/ArtistProfile/")
                  ? toggleMenu("m8", nftId ? nftId : music["nftId"])
                  : onHistory
                  ? onHistory(true)
                  : navTo(
                      `/app/${
                        isPlaylistNft ? "PlaylistNftDetail" : "NftDetail"
                      }/${nftId ? nftId : music["nftId"]}`
                    )
              }
              style={{
                position: "absolute",
                width: "30px",
                left: "6px",
                bottom: "8px",
              }}
              src={Images.near_nft}
              alt="Near"
            />
          )
        ) : (
          tab != 1 &&
          (tip ? (
            <TipCount tip={tip} />
          ) : tab != 1 && listens ? (
            <TipCount listens={listens} />
          ) : null)
        )}
      </Box>
      <Stack spacing="1">
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ width: '100%' }}
        >
          <Typography
            components="p"
            className="fs-16  text-left"
            onClick={() =>
              handleSongNameClick(music["title"], isArtist, isPlaylist)
            }
            title={isArtist ? fullName(music) : music["title"]}
            sx={{ color: 'var(--text-primary, #FFFFFF)' }}
          >
            {isArtist
              ? size < 600
                ? truncate(fullName(music), 9)
                : // : truncate(fullName(music), 50)
                  truncate(fullName(music), 22)
              : size < 600
              ? truncate(music["title"], 9)
              : truncate(music["title"], 22)}
          </Typography>

          {isNft && isPrivate ? (
            <LockIcon className="__small_icon __private" />
          ) : isPlaylistNft && isPrivate ? (
            <LockIcon className="__small_icon __private" />
          ) : isMusic && music["private"] ? (
            <LockIcon className="__small_icon __private" />
          ) : isPlaylist && music["private"] ? (
            <LockIcon className="__small_icon __private" />
          ) : null}

          {isArtist && music["isVerified"] ? (
            <img
            src={VerificationSVG}
            alt="Verified"
            style={{
              border: "0px solid #FFEE20",
              borderRadius: "50%",
              width: "22px",   // Adjust width as needed
              height: "22px",  // Adjust height as needed
              padding: "2px"   // Adjust padding as needed
              }}
            />
          ) : isStreaming ? (
            <Stack direction="row" alignItems="center" gap="5px" sx={{ marginLeft: '8px' }}>
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  background: "#E3293E",
                  borderRadius: "50%",

                }}
              ></div>
              <Typography className="fs-14">{t("live")}</Typography>
            </Stack>
          ) : null}
        </Stack>

        {(isPlaylist || isStreaming) && !isSearch ? (
          <Typography
            className="text-fade fs-12 fade-text-60 text-left"
            onClick={() => reditectToProfile(music)}
          >
            {music["createdByDetails"] &&
            typeof music["createdByDetails"] === "object" &&
            tab !== 1
              ? fullName(music["createdByDetails"])
              : music["ownerDetails"]
              ? fullName(music["ownerDetails"])
              : owner
              ? fullName(owner)
              : music["createdBy"]}
          </Typography>
        ) : null}
        <Stack
          style={{
            display: "flex",
            flexDirection: "row",
            overflowY: "scroll",
            gap: "6px",
          }}
          className="scroll_display_musicCard"
        >
          {isAlbum ? null : music.artistData ? (
            music.artistData.length > 1 ? (
              music.artistData.map((artist, index) => (
                <Typography
                  onClick={() => {
                    music["artistData"]
                      ? navTo(`/app/ArtistProfile/${artist.uId}`)
                      : music["owner"]
                      ? navTo(
                          `/app/ArtistProfile/${music["owner"]["_id"]}`
                        )
                      : typeof music["uploader"] === "object"
                      ? navTo(
                          `/app/ArtistProfile/${music["uploader"]["_id"]}`
                        )
                      : navTo(`/app/ArtistProfile/${music["uploader"]}`);
                  }}
                  key={index}
                  component="p"
                  className="text-fade fs-12 fade-text-60 text-left _cp"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {artist?.displayArtistName}
                  {music.artistData.length - 1 == index ? "" : ","}
                </Typography>
              ))
            ) : (
              music.artistData.map((artist, index) => (
                <Typography
                  onClick={() => {
                    music["artistData"]
                      ? navTo(`/app/ArtistProfile/${artist.uId}`)
                      : music["owner"]
                      ? navTo(
                          `/app/ArtistProfile/${music["owner"]["_id"]}`
                        )
                      : typeof music["uploader"] === "object"
                      ? navTo(
                          `/app/ArtistProfile/${music["uploader"]["_id"]}`
                        )
                      : navTo(`/app/ArtistProfile/${music["uploader"]}`);
                  }}
                  key={index}
                  component="p"
                  className="text-fade fs-12 fade-text-60 text-left _cp"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {artist?.displayArtistName}
                </Typography>
              ))
            )
          ) : (
            <Typography
              onClick={() => {
                music["owner"]
                  ? navTo(`/app/ArtistProfile/${music["owner"]["_id"]}`)
                  : typeof music["uploader"] === "object"
                  ? navTo(
                      `/app/ArtistProfile/${music["uploader"]["_id"]}`
                    )
                  : navTo(`/app/ArtistProfile/${music["uploader"]}`);
              }}
              components="p"
              className="text-fade fs-12 fade-text-60 text-left"
            >
              {isTopMusic
                ? music["artist"]
                : isMusic
                ? size < 600
                  ? music["artist"] //if artist then show artist otherwise uploader name
                    ? frontend_artist
                    : fullName(music["uploader"])
                  : music["artist"].replace("/", ",")
                  ? frontend_artist
                  : fullName(music["uploader"] ? music["uploader"] : "")
                : music.artist}
            </Typography>
          )}
        </Stack>
        {isPlaylist && !isFeature ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {music["music"] ? (
              <Typography className="fs-11" color="primary">
                {typeof music["music"] === "number"
                  ? music["music"]
                  : music["music"].length}{" "}
                {t("studio.songs")}
              </Typography>
            ) : null}

            {music["duration"] ? (
              <Typography className="fs-11" sx={{ color: "#62FFE1" }}>
                {convertHMS(
                  music["duration"] ? music["duration"] : music["totalDuration"]
                )}
              </Typography>
            ) : null}
          </Stack>
        ) : null}
        {(isMusic || isPlaylist || isNft) && !isStreaming && !isSearch ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack direction="row" gap="5px" alignItems="center">
              <img
                style={{ width: "13px" }}
                src={Images.listen_yellow}
                alt="listen"
              />
              <Typography
                className="fs-11"
                color="primary"
                title={music["countValue"] ? music["countValue"] : ""}
              >
                {kFormatter(
                  music["listens"]
                    ? music["listens"].toFixed(0)
                    : music["streamCount"]
                    ? music["streamCount"].toFixed(0)
                    : music["streamingCount"]
                    ? music["streamingCount"].toFixed(0)
                    : 0
                )}
              </Typography>
            </Stack>
            {/* {music["amount"] || music["highestBid"] ? (
              <Stack direction="row" gap="5px" alignItems="center">
                <img
                  style={{ width: "13px" }}
                  src={Images.tip_blue}
                  alt="listen"
                />
                <Typography
                  className="fs-11"
                  sx={{ color: "#62FFE1" }}
                  onClick={() =>
                    music["nftId"]
                      ? navTo(
                          `/app/${
                            isPlaylistNft ? "PlaylistNftDetails" : "NftDetails"
                          }/${music["nftId"]}`
                        )
                      : null
                  }
                >
                  {music["amount"]
                    ? `$${music["amount"]}`
                    : music["highestBid"]
                    ? `$${music["highestBid"]}`
                    : "N/A"}
                </Typography>
              </Stack>
            ) : null} */}
          </Stack>
        ) : null}
        {isArtist || isStreaming ? (
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {
              isArtist ? (
                <Stack direction="row" gap="5px" alignItems="center">
                  <PersonOutlineIcon sx={{ width: "18px" }} color="primary" />
                  <Typography className="fs-14" color="primary">
                    {music["followers"]
                      ? music["followers"]
                      : music["followersCount"]
                      ? music["followersCount"]
                      : 0}{" "}
                    {t("myProfile.followers")}
                  </Typography>
                </Stack>
              ) : null
              //Audience count commented
              // <Stack direction="row" gap="5px" alignItems="center">
              //   <img src={Images.people} sx={{ width: "18px" }} alt="" />
              //   <Typography className="fs-14" color="primary">
              //     {music["audienceCount"] ? music["audienceCount"] : "0"}
              //   </Typography>
              // </Stack>
            }
          </Stack>
        ) : null}
        {ownerRoyalty ? (
          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{
              marginTop: "3px",
              backgroundColor: "#343434",
              borderRadius: "6px",
              padding: "5px",
            }}
          >
            <Stack direction="row" gap="5px" alignItems="center">
              <img
                style={{ width: "13px" }}
                src={Images.listen_yellow}
                alt="listen"
              />
              <Typography className="fs-11" color="default">
                {music["ownerRoyalty"] ? music["ownerRoyalty"] : 0} % to Owner
              </Typography>
            </Stack>
          </Stack>
        ) : null}
      </Stack>
      {isMenu ? (
        <OutsideClickHandler onOutsideClick={() => setMenu(false)}>
          <Box className="__music_card_menu" sx={{ position: "absolute" }}>
            {actions.map(({ action, key }, index) =>
              action ? (
                <Typography
                  className="__music_card_menu_item"
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    setMenu(false);
                    toggleMenu(
                      key,
                      isMusic
                        ? music["_id"]
                        : isArtist
                        ? music["_id"]
                        : isPlaylist
                        ? music["_id"]
                        : isNft
                        ? music["_id"]
                        : ""
                    );
                  }}
                >
                  {action}
                </Typography>
              ) : null
            )}
          </Box>
        </OutsideClickHandler>
      ) : null}
      {birthYear ? (
        <DobPopup open={birthYear} handleClose={() => handleTip()} />
      ) : null}
      {loading ? <Loader message={message} /> : null}
    </Box>
  );
}
